import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '../autocomplete';
import ActionButton from '../action-button';
import FieldStatus from '../field-status';

const DomainSelector = ({
  children = null,
  captions,
  isLoading = false,
  errorMessage = null,
  onInput = Function.prototype,
  onChange = Function.prototype,
  defaultInputValue = null,
  onButtonClick = Function.prototype,
  onFocus = Function.prototype,
  onBlur = Function.prototype,
  onKeyDown = Function.prototype,
  loadAutocompleteOptions,
}) => (
  <div className="ws-ui-domain-selector">
    <div className="ws-ui-domain-selector__field-group">
      <div className="ws-ui-domain-selector__search-field">
        <Autocomplete
          invalid={Boolean(errorMessage)}
          size="large"
          clearable={false}
          placeholder={captions.search.placeholder}
          onInputChange={onInput}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          defaultInputValue={defaultInputValue}
          blurInputOnSelect
          asyncConfig={{
            loadOptions: loadAutocompleteOptions,
          }}
        />
        {errorMessage && <FieldStatus text={errorMessage} appearance="error" />}
      </div>
      <div className="ws-ui-domain-selector__search-button">
        <ActionButton
          isLoading={isLoading}
          label={captions.search.button}
          format="solid"
          disabled={Boolean(errorMessage)}
          size="large"
          onClick={onButtonClick}
        />
      </div>
    </div>

    <div className="ws-ui-domain-selector__content">{children}</div>
  </div>
);

DomainSelector.propTypes = {
  children: PropTypes.node,
  captions: PropTypes.shape({
    search: PropTypes.shape({
      button: PropTypes.string,
      placeholder: PropTypes.string,
    }),
  }).isRequired,
  errorMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  onInput: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onButtonClick: PropTypes.func,
  loadAutocompleteOptions: PropTypes.func.isRequired,
  defaultInputValue: PropTypes.string,
};

export default DomainSelector;
